import Vue from 'vue'
import image from './image'
import support from './support'

Vue.mixin(image)
Vue.mixin(support)
